export default {
//    service : 'http://127.0.0.1:8000'
//   service: "https://api.bookwedgo.com/api",
  service: "https://apiprod.bookwedgo.com/api",
  // service : 'http://bwgtest.aspirantlabs.com/api'
  // service : 'http://173.230.149.225:8009/api'
  // service : 'http://127.0.0.1:8000/api'
};
